import { Flex, Text } from "@radix-ui/themes";
import React, { Dispatch, SetStateAction } from "react";
import _, { compact, isUndefined } from "lodash";
import { t } from "i18next";
import { Button } from "../../ui/Button";
import { TbArrowsSort, TbSortAscending, TbSortDescending } from "react-icons/tb";
import { SortingState } from "@tanstack/react-table";

type Props = {
  sortingState: [SortingState, Function];
  categoryName: string;
  columnId: string;
};

const TableSortingCategory = ({ sortingState, categoryName, columnId }: Props) => {
  const [sorting, setSorting] = sortingState;
  const sort = sorting.find((sort) => sort.id == columnId);

  const changeFilter = () => {
    if (isUndefined(sort)) {
      setSorting([{ id: columnId, desc: true }]);
    } else {
      setSorting([{ id: columnId, desc: !sort.desc }]);
    }
  };

  return (
    // <div className="flex justify-between items-center text-sm w-full">
    //   <div className="font-medium">{t(categoryName)}</div>
    //   <span className="">
    //     <Button variant="default" size="small_icon" onClick={changeFilter}> 
    //       {isUndefined(sort) ? <TbArrowsSort /> : sort.desc ? <TbSortAscending /> : <TbSortDescending />}
    //     </Button>
    //   </span>
    // </div>
    <div className="px-1 py-1 rounded bg-muted flex justify-between items-center cursor-pointer hover:bg-primary hover:text-white" onClick={changeFilter}>
      <div className="space-x-2 flex items-center px-1 justify-between w-full">
        <span>{t(categoryName)}</span>
      </div>
      {isUndefined(sort) ? <TbArrowsSort size={18} className="w-6 hover:text-white"/> : sort.desc ? <TbSortAscending size={18} className="w-6 hover:text-white"/> : <TbSortDescending size={18} className="w-6 hover:text-white"/>}
    </div>
  );
};

export default TableSortingCategory;
